import React, { useState } from "react";
//import NewReviewPageInsideComponent from "./ReviewsPageInsideComponent/NewReviewPageInsideComponent";
import AllReviewPageInsideComponent from "./ReviewsPageInsideComponent/AllReviewPageInsideComponent";
import { Button } from "react-bootstrap";

const ReviewsPageComponent = (props) => {
  //state
  const [insidePageTab, setInsidePageTab] = useState("1");

  const pageChangeButtonClickHandler = (value) => (e) => {
    setInsidePageTab(value);
  };

  return (
    <React.Fragment>
      <div className="row super_admin_all_users_toggle_button-tab">
        <div className="col-12 super_admin_all_users_toggle_button-tab">
          <div className="Right-side-heading-text ml-0">
            <div className="d-flex align-items-center">
              {/* <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "1" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("1")}
              >
                New
              </Button> */}
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "1" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("1")}
              >
                Restaurants
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "2" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("2")}
              >
                Seating
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "3" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("3")}
              >
                Experience
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "4" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("4")}
              >
                Orders
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "5" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("5")}
              >
                Items
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "6" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("6")}
              >
                Pay
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12  pl-0">
        <AllReviewPageInsideComponent
          selectedTab={insidePageTab}
          data={props.data}
          clickedSearch={props.clickedSearch}
          sortByDate={props.sortByDate}
          search={props.search}
          startDay={props.startDay}
          endDay={props.endDay}
          sortByDay={props.sortByDay}
          favouriteFilter={props.favouriteFilter}
          startDate={props.startDate}
          endDate={props.endDate}
          sortBy={props.sortBy}
          filterBy={props.filterBy}
        />
      </div>
    </React.Fragment>
  );
};

export default ReviewsPageComponent;
